<template>
  <div class="addInjectable">
    <el-dialog title="" v-loading="loading" :visible.sync="editSum" center class="dialogItem" :close-on-click-modal="false">
      <h3>编辑登记表-皮肤科</h3>
      <el-form label-width="100px" :inline="true" :model="formData" ref="formData" :rules="rules">
        <el-divider>客户基本信息</el-divider>
        <h5>客户基本信息</h5>
        <div class="card">
          <el-form-item label="手机号">
            <el-input v-model="formData.clientMobile" placeholder="请输入手机号" @input="testSX" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="卡号">
            <el-input v-model="formData.clientCard" placeholder="请输入卡号" @input="testSX" onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="姓名" class="service">
            <el-input v-model="formData.clientName" placeholder="请输入客户姓名" @input="testSX"></el-input>
          </el-form-item>
          <el-button class="info" type="primary" @click="getInfo" size="mini">获取信息</el-button>
          <el-form-item label="客服" prop="serviceName">
            <el-input v-model="formData.serviceName" placeholder="请输入客服姓名" @input="testSX"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="clientSex">
            <el-select v-model="formData.clientSex" clearable="" placeholder="请选择性别" @input="testSX">
              <el-option v-for="(item,index) in sexey" :key="index" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年龄">
            <el-input v-model="formData.clientAge" placeholder="请输入年龄" @input="testSX"></el-input>
          </el-form-item>
        </div>
        <h5>手术登记表</h5>
        <div class="card">
          <el-form-item label="日期" prop="time">
            <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="formData.time" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="类别" prop="category">
            <el-select v-model="formData.category" placeholder="请选择类别">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <div class="card" v-for="(item, index) in formData.registerInformationDtoList " :key="index">
            <el-form-item label="诊断" :prop="'registerInformationDtoList.' + index + '.diagnosis'" :rules="rules.diagnosis">
              <el-select allow-create @keydown.enter.native="enterDoctor($event,index,24)" @change="diagnosisChange($event,index)" default-first-option @input="testSX" @visible-change='diagnosischange' v-model="item.diagnosis" @focus="diagnosisFocus($event,index)" filterable remote clearable placeholder="请输入诊断名称(多选)" multiple :filter-method="diagnosisMatch">
                <el-option v-for="item in diagnosisOptions" :key="item.id" :label="item.menuName" :value="item.menuName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="治疗名称" :prop="'registerInformationDtoList.' + index + '.injectionPart'" :rules="rules.injectionPart">
              <el-select @change="cureChange($event,index)" @keydown.enter.native="enterDoctor($event,index,25)" default-first-option @input="testSX" filterable remote clearable v-model="item.injectionPart" placeholder="请选择注射部位(多选)" @focus="injectionFocus($event,index)" multiple :filter-method="injectMatch">
                <el-option v-for="item in injectionOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="注射医生" :prop="'registerInformationDtoList.' + index + '.partDoctor'" :rules="rules.partDoctor">
              <el-select @keydown.enter.native="enterDoctor($event,index,1)" default-first-option @input="testSX" @change="doctorChange($event,index)" v-model="item.partDoctor" multiple @focus="docotrFocus(15)" filterable remote clearable placeholder="请输入注射医生姓名(多选)" :filter-method="(value) => docotrMatch(value, 15)">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="当班护士" :prop="'registerInformationDtoList.' + index + '.dutyNurse'" :rules="rules.dutyNurse">
              <el-select @keydown.enter.native="enterDoctor($event,index,2)" default-first-option @input="testSX" @change="nurseChange($event,index)" v-model="item.dutyNurse" multiple @focus="docotrFocus(16)" filterable remote clearable placeholder="请输入当班护士姓名(多选)" :filter-method="(value) => docotrMatch(value, 16)">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="麻醉方式" :prop="'registerInformationDtoList.' + index + '.anesthesiaMode'" :rules="rules.anesthesiaMode">
              <el-select @change="anesChange($event,index)" @input="testSX" v-model="item.anesthesiaMode" placeholder="请选择麻醉方式" @focus="anesFocus" clearable>
                <el-option v-for="item in anesOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" :prop="'registerInformationDtoList.' + index + '.productRemark'" :rules="rules.productRemark">
              <el-input @input="remarkChange($event,index)" v-model="item.productRemark"></el-input>
            </el-form-item>
            <el-form-item class="button">
              <el-button size="mini" type="danger" @click.prevent="removeForm(item,index)" v-show="index > 0">
                <i class="el-icon-delete"></i>
              </el-button>
            </el-form-item>
          </div>
        </div>
        <el-form-item style="text-align: right;margin-right:5%;">
          <el-button @click="addForm" type="primary" size="mini">新增手术登记表</el-button>
        </el-form-item>
        <el-divider>耗材登记表</el-divider>
        <h5>院区信息</h5>
        <div class="card">
          <el-form-item label="院区" prop="areaName">
            <el-select v-model="formData.areaName" placeholder="请选择院区">
              <el-option v-for="item in areaOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="科室">
            <el-input disabled v-model="formData.dsepartmentName"></el-input>
          </el-form-item>
        </div>
        <h5>手术信息</h5>
        <div>
          <div class="card" v-for="(item, index) in formData.operationMaterials " :key="index">
            <el-form-item label="医生姓名" :prop="'operationMaterials.' + index + '.doctorName'" :rules="rules.doctorName">
              <el-select @keydown.enter.native="enterDoctor($event,index,4)" default-first-option @input="testSX" v-model="item.doctorName" @focus="docotrFocus(15)" filterable remote clearable placeholder="请输入医生姓名(多选)" multiple :filter-method="(value) => docotrMatch(value, 15)">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="护士姓名" :prop="'operationMaterials.' + index + '.nurseName'" :rules="rules.nurseName">
              <el-select @keydown.enter.native="enterDoctor($event,index,5)" default-first-option @input="testSX" v-model="item.nurseName" @focus="docotrFocus(16)" filterable remote clearable placeholder="请输入护士姓名(多选)" multiple :filter-method="(value) => docotrMatch(value, 16)">
                <el-option v-for="item in doctorOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
              </el-select>
            </el-form-item>
            <!-- 新增注射产品 -->
            <div>
              <div class="allFlex" v-for="(domain, idx) in item.injectionProductList " :key="idx">
                <div class="flex">
                  <el-form-item label="注射产品" :prop="'operationMaterials.'+index+'.injectionProductList.'+idx+'.productName'" :rules="rules.productName">
                    <el-select ref="injectName" @keydown.enter.native="enterDoctor($event,index,6,idx)" default-first-option @change="injectChange($event,idx,index)" @visible-change='bbChange' v-model="domain.productName" filterable remote clearable placeholder="请选择注射产品" @focus="injectFocus" @input="testSX" :filter-method="domainMatch">
                      <el-option v-for="(item,index) in injectOptions" :key="index" :label="item.menuName" :value="item.menuName"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="规格" :prop="'operationMaterials.'+index+'.injectionProductList.'+idx+'.specification'" :rules="rules.specification">
                    <el-select @change="specChange($event,idx,index)" default-first-option v-model="domain.specification" placeholder="请选择注射产品规格" clearable @input="testSX" filterable remote>
                      <el-option v-for="(item,index) in domain.specOptions" :key="index" :label="item.menuSpec" :value="item.menuSpec"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="数量" class="list" :prop="'operationMaterials.'+index+'.injectionProductList.'+idx+'.number'" :rules="rules.number">
                    <el-input v-model="domain.number" placeholder="请输入产品数量" @input="testSX"></el-input>
                  </el-form-item>
                  <el-form-item class="list">
                    <el-input @input="inputChange($event,index,idx)" v-model="domain.amount" placeholder="请输入"></el-input>
                  </el-form-item>
                  <el-button size="mini" type="danger" @click.prevent="remove(domain,idx,index)" v-show="idx > 0">
                    <i class="el-icon-delete"></i>
                  </el-button>
                </div>
                <div class="inject">
                  <el-form-item label="注射部位" :prop="'operationMaterials.'+index+'.injectionProductList.'+idx+'.injectionPart'" :rules="rules.surgeryName">
                    <el-select @keydown.enter.native="enterDoctor($event,index,3,idx)" default-first-option @input="testSX" multiple @visible-change='infoChange' v-model="domain.injectionPart" @focus="infoFocus" filterable remote clearable placeholder="请输入手术名称(多选)" :filter-method="infoMatch">
                      <el-option v-for="item in infoOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="flex" v-for="(next, nextIndex) in domain.productList " :key="nextIndex">
                  <el-form-item label="产品名称" :prop="`operationMaterials.${index}.injectionProductList.${idx}.productList.${nextIndex}.productName`" :rules="rules.productName">
                    <el-select ref="productName" @keydown.enter.native="enterDoctor($event,index,30, idx,nextIndex)" default-first-option @change="productChange($event,idx,index,nextIndex)" @visible-change='aaChange' v-model="next.productName" filterable remote clearable placeholder="请选择产品名称" @focus="productFocus" @input="testSX" :filter-method="productMatch">
                      <el-option v-for="(item) in productOptions" :key="item.id" :label="item.menuName" :value="item.menuName"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="规格" :prop="`operationMaterials.${index}.injectionProductList.${idx}.productList.${nextIndex}.specification`" :rules="rules.specification">
                    <el-select @change="domainChange($event,idx,index,nextIndex)" default-first-option :disabled="specDisabled" v-model="next.specification" placeholder="请选择产品规格" clearable @input="testSX" filterable remote>
                      <el-option v-for="(item,index) in next.specOptions" :key="index" :label="item.menuSpec" :value="item.menuSpec"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="数量" class="list1" :prop="`operationMaterials.${index}.injectionProductList.${idx}.productList.${nextIndex}.number`" :rules="rules.number">
                    <el-input v-model="next.number" placeholder="请输入数量" @input="testSX"></el-input>
                  </el-form-item>
                  <el-button size="mini" type="danger" @click.prevent="editRemoveDomain(index,idx,next,nextIndex)" v-show="nextIndex > 0">
                    <i class="el-icon-delete"></i>
                  </el-button>
                </div>
                <el-form-item style="text-align: right;margin-right:5%;">
                  <el-button @click="editAddDomain(index,idx)" type="primary" size="mini">新增产品</el-button>
                </el-form-item>
              </div>
              <el-form-item style="text-align: right;margin-right:5%;">
                <el-button @click="editDomain(index)" type="primary" size="mini">新增注射产品及对应耗材</el-button>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="footer">
          <el-form-item>
            <el-button type="danger" @click="resetForm('formData')">取 消</el-button>
            <el-button type="primary" @click="doAddgoods('formData')">确 定</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <!-- 选择信息弹框 -->
    <el-dialog center class="dialogItem" :visible.sync="dialogFormCheck" append-to-body>
      <el-checkbox-group class="cardName" size="medium" v-model="loadOption">
        <el-checkbox-button style="display:block;" v-for="(item,index) in loadOptions" :key="index" :label="item.clientCard">
          <div class="infoSource">
            <span><span class="nameSex">姓名:</span>{{item.clientName}}</span>
            <span><span class="nameSex">性别:</span>{{item.clientSex}}</span>
          </div>
          <div class="infoSource"><span class="nameSex">手机号:</span>{{item.clientMobile.replaceAll('，', ' ')}}</div>
          <div class="infoSource"><span class="nameSex">卡号:</span>{{item.clientCard}}</div>
          <div class="infoSource"><span class="nameSex">信息来源:</span>{{item.scName}}</div>
        </el-checkbox-button>
      </el-checkbox-group>
      <div class="footer">
        <el-button type="primary" icon="el-icon-arrow-left" @click="lastPage">上一页</el-button>
        <el-button type="primary" @click="nextpage">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        <el-button type="danger" @click="dialogFormCheck = false">取 消</el-button>
        <el-button type="primary" @click="addInfo">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pinyin from 'pinyin-match'
import Store from "../../assets/common.vue";
export default {
  props: ['formData',],

  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      }
      else if (value.length < 8) {
        return callback(new Error('手机号需要大于八位数'));
      }
      else if (isNaN(value)) {
        return callback(new Error('手机号格式不正确'));
      }
      else {
        callback();
      }
    };
    return {
      editSum: false,
      loading: false,
      options: [{
        value: '内',
        label: '内'
      }, {
        value: '外',
        label: '外'
      },],
      dialogFormCheck: false,
      loadOption: [],
      loadOptions: [],
      rules: {
        clientMobile: [
          { required: true, validator: checkPhone, trigger: 'blur', }
        ],
        clientCard: [
          { required: true, message: '请添加客户卡号', trigger: 'blur' },
        ],
        serviceName: [
          { required: true, message: '请添加客服姓名', trigger: 'blur' },
        ],
        clientName: [
          { required: true, message: '请添加客户姓名', trigger: 'blur' },
        ],
        clientSex: [
          { required: true, message: '请添加客户性别', trigger: 'blur' },
        ],
        time: [
          { required: true, message: '请添加日期', trigger: 'blur' },
        ],
        areaName: [
          { required: true, message: '请添加院区', trigger: 'blur' },
        ],
        surgeryName: [
          { required: true, message: '请添加手术名称', trigger: 'blur' },
        ],
        doctorName: [
          { required: true, message: '请添加医生姓名', trigger: 'blur' },
        ],
        nurseName: [
          { required: true, message: '请添加护士姓名', trigger: 'blur' },
        ],
        productName: [
          { required: true, message: '请添加产品名称', trigger: 'blur' },
        ],
        specification: [
          { required: true, message: '请添加产品规格', trigger: 'blur' },
        ],
        number: [
          { required: true, message: '请添加产品数量', trigger: 'blur' },
        ],
        diagnosis: [
          { required: true, message: '请添加诊断名称', trigger: 'blur' },
        ],
        injectionPart: [
          { required: true, message: '请添加注射部位', trigger: 'blur' },
        ],
        partDoctor: [
          { required: true, message: '请添加注射医生', trigger: 'blur' },
        ],
        dutyNurse: [
          { required: true, message: '请添加当班护士', trigger: 'blur' },
        ],
        // anesthetistName: [
        //   { required: true, message: '请添加麻醉医生', trigger: 'blur' },
        // ],
        anesthesiaMode: [
          { required: true, message: '请添加麻醉方式', trigger: 'blur' },
        ],
        category: [
          { required: true, message: '请添加类别', trigger: 'blur' },
        ],
      },
      sexey: [
        {
          label: '男',
          value: '0'
        }, {
          label: '女',
          value: '1'
        },
      ],
      disabled: true,
      areaOptions: [
        {
          id: '伯思立',
          menuName: '伯思立'
        }, {
          id: '百达丽',
          menuName: '百达丽'
        }, {
          id: '翡立思',
          menuName: '翡立思'
        }
      ],
      diagnosisOptions: [],
      infoOptions: [],
      anesOptions: [],
      productOptions: [],
      doctorOptions: [],
      injectionOptions: [],
      injectOptions: [],
      specDisabled: false,
      ageOptions: [],
      allData: {},
      list9: [],
      list15: [],
      list16: [],
      list17: [],
      list2: [],
      list8: [],
      list4: [],
      list18: [],
      newData: [],
      listData: [],
    }
  },
  created() {
    api.requestQuiet("/register/findDermatologyRegisterMenuList", {}, (res) => {
      if (res.result == true) {
        this.allData = res.data
        this.allData.forEach(ele => {
          if (ele.menuType == 9) {
            this.list9.push(ele)
          } if (ele.menuType == 17) {
            this.list17.push(ele)
          } else if (ele.menuType == 15) {
            this.list15.push(ele)
          } else if (ele.menuType == 16) {
            this.list16.push(ele)
          } else if (ele.menuType == 2) {
            this.list2.push(ele)
          } else if (ele.menuType == 8) {
            this.list8.push(ele)
          } else if (ele.menuType == 4) {
            this.list4.push(ele)
          } else if (ele.menuType == 18) {
            this.list18.push(ele)
          }
        })
        this.loading = false
      } else {
        _g.toast("warning", res.errMsg);
      }

    }, (err) => {
      this.loading = true
    })
  },
  methods: {
    inputChange(val, index, idx) {
      this.formData.operationMaterials[index].injectionProductList[idx].amount = this.formData.operationMaterials[index].injectionProductList[idx].amount.replace(/[^0-9.]/g, '')
    },
    // 取消
    resetForm(formData) {
      this.$refs[formData].resetFields();
      this.formData.clientMobile = ''
      this.formData.clientCard = ''
      this.formData.clientName = ''
      this.editSum = false
    },
    initAge() {
      for (let i = 1; i <= 100; i++) {
        this.ageOptions.push(i);
      }
    },
    testSX() {
      this.$forceUpdate()
    },
    // 下一页
    nextpage() {
      let data = {
        clientMobile: this.formData.clientMobile,
        clientCard: this.formData.clientCard,
        clientName: this.formData.clientName,
        pageIndex: Lockr.get("selected") + 1,
      }
      api.requestQuiet("/register/getClientInformation", data, (res) => {
        console.log(res)
        if (res.result == true) {
          //当前页数+1
          this.loadOptions = res.data.mapList
          Lockr.set("selected", res.data.pageIndex)
        } else {
          _g.toast("warning", '已经是最后一页啦!');
          Lockr.set("selected", res.data.pageIndex)
        }
      }, (err) => {
        this.loading = false
      });
    },
    // 上一页
    lastPage() {
      if (Lockr.get("selected") < 2) {
        _g.toast("warning", '已经是第一页啦!');
      } else {
        let data = {
          clientMobile: this.formData.clientMobile,
          clientCard: this.formData.clientCard,
          clientName: this.formData.clientName,
          pageIndex: Lockr.get("selected") - 1,
        }
        api.requestQuiet("/register/getClientInformation", data, (res) => {
          console.log(res)
          if (res.result == true) {
            this.loadOptions = res.data.mapList
            Lockr.set("selected", res.data.pageIndex)
          }
        }, (err) => {
          this.loading = false
        });
      }
    },
    // 编辑时新增部位
    editAddDomain(index, idx) {
      console.log(index);
      this.formData.operationMaterials[index].injectionProductList[idx].productList.push({
        productName: "",
        specification: '',
        number: '',
        amount: "",
        key: Date.now()
      });
    },
    // 编辑时删除部位
    // 编辑时删除部位
    editRemoveDomain(listIndex, idx, item, nextIndex) {
      var index = this.formData.operationMaterials[listIndex].injectionProductList[idx].productList.indexOf(item)
      if (index !== -1) {
        this.formData.operationMaterials[listIndex].injectionProductList[idx].productList.splice(nextIndex, 1)
      }
    },
    // 编辑时新增部位
    editDomain(index) {
      this.formData.operationMaterials[index].injectionProductList.push({
        productName: "",
        specification: '',
        number: '',
        productList: [{
          productName: "",
          specification: '',
          number: '',
          amount: "",
          key: Date.now()
        }],
        key: Date.now()
      });
    },
    // 编辑时删除部位
    remove(item, listIndex, nextIndex) {
      var index = this.formData.operationMaterials[nextIndex].injectionProductList.indexOf(item)
      if (index !== -1) {
        this.formData.operationMaterials[nextIndex].injectionProductList.splice(listIndex, 1)
      }
    },
    // 添加手术名称
    removeDomain(item, listIndex) {
      var index = this.formData.operationMaterials.indexOf(item)
      if (index !== -1) {
        this.formData.operationMaterials.splice(listIndex, 1)

        this.formData.registerInformationDtoList.splice(listIndex, 1)
      }
    },
    // 添加手术登记表
    removeForm(item, listIndex) {
      var index = this.formData.registerInformationDtoList.indexOf(item)
      if (index !== -1) {
        this.formData.registerInformationDtoList.splice(listIndex, 1)

        this.formData.operationMaterials.splice(listIndex, 1)
      }
    },
    addForm() {
      this.formData.registerInformationDtoList.push({
        diagnosis: this.formData.registerInformationDtoList[0].diagnosis,//诊断
        injectionPart: this.formData.registerInformationDtoList[0].injectionPart,
        partDoctor: this.formData.registerInformationDtoList[0].partDoctor,
        dutyNurse: this.formData.registerInformationDtoList[0].dutyNurse,//当班护士
        anesthetistName: this.formData.registerInformationDtoList[0].anesthetistName,//注射医生
        anesthesiaMode: this.formData.registerInformationDtoList[0].anesthesiaMode,//麻醉方式
        productRemark: this.formData.registerInformationDtoList[0].productRemark,
        key: Date.now()
      });
    },
    openDialog1Visible() {
      this.editSum = true;
    },
    openLoading() {
      if (this.allData && this.allData.length != 0) {
        console.log('00000');
        this.loading = false
      } else {
        console.log('11111');
        this.loading = true
      }
    },
    testSX() {
      this.$forceUpdate()
    },
    // 获取信息
    getInfo() {
      this.formData.clientAge = ""
      this.formData.clientSex = ''
      this.formData.serviceName = ''
      this.loadOption = []
      this.loading = true
      let data = {
        clientMobile: this.formData.clientMobile,
        clientCard: this.formData.clientCard,
        clientName: this.formData.clientName
      }
      api.requestQuiet("/register/getClientInformation", data, (res) => {
        console.log(res)
        if (res.result == true) {
          this.loading = false
          if (res.data.length == 1) {
            this.formData.clientMobile = res.data.mapList[0].clientMobile
            this.formData.clientAge = res.data.mapList[0].clientAge
            this.formData.clientCard = res.data.mapList[0].clientCard
            this.formData.clientSex = res.data.mapList[0].clientSex
            this.formData.clientName = res.data.mapList[0].clientName
            this.formData.serviceName = res.data.mapList[0].serviceName
          } else {
            this.dialogFormCheck = true
            this.loadOptions = res.data.mapList
          }
        } else {
          this.loading = false
          //   获取信息之后是否可以编辑信息
          this.disabled = false
          // 接口未查询到
          this.formData.information = 1//0是1否   是否宏脉数据
          _g.toast("warning", '请手动添加客户信息');
        }
      }, (err) => {
        this.loading = false
      });
    },
    // 诊断选择
    diagnosisFocus(e, index) {
      this.diagnosisOptions = []
      if (this.formData.registerInformationDtoList[index].injectionPart.length == 0) {
        this.diagnosisOptions = this.list17
        this.newData = this.diagnosisOptions
      } else if (this.formData.registerInformationDtoList[index].injectionPart.length != 0) {
        // 筛选当前选择的手术名称所对应的诊断
        let date = this.list18.filter(item => this.formData.registerInformationDtoList[index].injectionPart.indexOf(item.menuName) > -1)
        let array = []
        let isClude = date.map((value) => value.menuName).indexOf('其他') > -1 || date.map((value) => value.menuName).indexOf('无') > -1
        // console.log(isClude);
        if (isClude == true) {
          this.diagnosisOptions = this.list17
          this.newData = this.diagnosisOptions
        } else if (isClude == false) {
          date.forEach(ele => {
            ele.registerMenuDtoList.forEach(item => {
              array.push(item)
            });
            // 数组去重 一个诊断对应多个手术名称
            if (array.length != 0) {
              let obj = {};
              let peon = array.reduce((cur, next) => {
                obj[next.menuName] ? "" : obj[next.menuName] = true && cur.push(next);
                return cur;
              }, []) //设置cur默认类型为数组，并且初始值为空的数组
              if (peon.length == 0) {
                this.diagnosisOptions = this.list17
              } else if (peon.length != 0) {
                this.diagnosisOptions = peon
                this.diagnosisOptions.unshift({ menuName: '无', id: 999999 }, { menuName: '其他', id: 111111 })
                this.newData = this.diagnosisOptions
              }
            } else {
              this.diagnosisOptions = this.list17
              this.newData = this.diagnosisOptions
            }
          });
        }
      }
    },
    diagnosischange(val) {
      if (val == false) {
        this.diagnosisOptions = []
      }
    },
    diagnosisMatch(val) {
      this.copydiagnosisOptions = Object.assign(this.newData)
      if (val) {
        this.diagnosisOptions = this.copydiagnosisOptions.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.menuName) {
            if (item.menuName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.menuName, val)
          }
        })
      } else {
        this.diagnosisOptions = this.copydiagnosisOptions
      }
      // })
    },
    // 耗材表手术名称
    infoFocus(e, index) {
      this.infoOptions = this.list9
    },
    infoChange(val) {
      if (val == false) {
        this.infoOptions = []
      }
    },
    infoMatch(val) {
      this.copyinfoOptions = Object.assign(this.list9)
      if (val) {
        this.infoOptions = this.copyinfoOptions.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.menuName) {
            if (item.menuName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.menuName, val)
          }
        })
      } else {
        this.infoOptions = this.copyinfoOptions
      }
      // })
    },
    // 麻醉方式
    anesFocus() {
      this.anesOptions = this.list2
    },
    docotrFocus(menuType) {
      if (menuType == 15) {
        this.doctorOptions = this.list15
      } else if (menuType == 16) {
        this.doctorOptions = this.list16
      }
    },
    docotrMatch(val, menuType) {
      if (menuType == 15) {
        this.copyOrderDetails = Object.assign(this.list15)
      } else if (menuType == 16) {
        this.copyOrderDetails = Object.assign(this.list16)
      }
      if (val) {
        this.doctorOptions = this.copyOrderDetails.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.menuName) {
            if (item.menuName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.menuName, val)
          }
        })
      } else {
        this.doctorOptions = this.copyOrderDetails
      }
      // })
    },
    // 选择产品名称
    productFocus() {
      this.productOptions = this.list8
    },
    aaChange(val) {
      if (val == false) {
        this.productOptions = []
      } else if (val == true) {
        this.productOptions = this.list8
      }
    },
    productChange(val, idx, index, nextIndex) {
      this.productOptions.forEach(ele => {
        if (ele.menuName == val) {
          if (val == '无') {
            this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].specification = '无'
            this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].number = '0'
            // this.specDisabled = true
          } else {
            this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].specification = ''
            this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].number = '1'
            this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].specOptions = ele.registerMenuDtoList
            this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].price = ele.price
          }
        }
        // else if (typeof (val) != typeof (ele.id)) {
        //   this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].specification = ''
        //   this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].number = '1'
        //   this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].specOptions = Store.specData
        // }

      });
    },
    domainChange(val, idx, index, nextIndex) {
      this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].specOptions.forEach(ele => {
        if (val == ele.menuSpec) {
          console.log(ele.price);
          this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].price = ele.price
        }
      });
    },
    productMatch(val) {
      this.copyproductOptions = Object.assign(this.list8)
      if (val) {
        this.productOptions = this.copyproductOptions.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.menuName) {
            if (item.menuName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.menuName, val)
          }
        })
      } else {
        this.productOptions = this.copyproductOptions
      }
      // })
    },
    // 选择注射产品
    injectFocus() {
      // })
      this.injectOptions = this.list4
    },
    bbChange(val) {
      if (val == false) {
        this.injectOptions = []
      } else if (val == true) {
        this.injectOptions = this.list4
      }
    },
    domainMatch(val) {
      this.copyinjectOptions = Object.assign(this.list4)
      if (val) {
        this.injectOptions = this.copyinjectOptions.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.menuName) {
            if (item.menuName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.menuName, val)
          }
        })
      } else {
        this.injectOptions = this.copyinjectOptions
      }
      // })
    },
    injectChange(val, idx, index) {
      this.injectOptions.forEach(ele => {
        if (ele.menuName == val) {
          if (val == '无') {
            this.formData.operationMaterials[index].injectionProductList[idx].specification = '无'
            this.formData.operationMaterials[index].injectionProductList[idx].number = '0'
            // this.specDisabled = true
          } else {
            this.formData.operationMaterials[index].injectionProductList[idx].specification = ''
            this.formData.operationMaterials[index].injectionProductList[idx].number = '1'
            this.formData.operationMaterials[index].injectionProductList[idx].specOptions = ele.registerMenuDtoList
          }
        }
        // else if (typeof (val) != typeof (ele.id)) {
        //   this.formData.operationMaterials[index].injectionProductList[idx].specOptions = Store.specData
        // }
      });
    },
    specChange(val, idx, index) {
      this.formData.operationMaterials[index].injectionProductList[idx].specOptions.forEach(ele => {
        if (val == ele.menuSpec) {
          console.log(ele.price);
          this.formData.operationMaterials[index].injectionProductList[idx].price = ele.price
        }
      });
    },
    arrHasOtherArr(arr, arr1) {
      return arr1.every(item => arr.includes(item))
    },
    // 选择注射部位
    injectionFocus(e, index) {
      this.injectionOptions = []
      let serviceRes = this.list17.map((value) => value.menuName)
      let isTrue = this.arrHasOtherArr(serviceRes, this.formData.registerInformationDtoList[index].diagnosis)
      if (this.formData.registerInformationDtoList[index].diagnosis.length == 0 || isTrue == false) {
        this.injectionOptions = this.list18
        this.listData = this.injectionOptions
      } else if (this.formData.registerInformationDtoList[index].diagnosis.length != 0 || isTrue == true) {
        let date = this.list17.filter(item => this.formData.registerInformationDtoList[index].diagnosis.indexOf(item.menuName) > -1)
        let isClude = date.map((value) => value.menuName).indexOf('其他') > -1 || date.map((value) => value.menuName).indexOf('无') > -1
        if (isClude == true) {
          this.injectionOptions = this.list18
          this.listData = this.injectionOptions
        } else if (isClude == false) {
          let array = []
          date.forEach(ele => {
            ele.registerMenuDtoList.forEach(item => {
              array.push(item)
            });
          });
          // 数组去重 一个诊断对应多个手术名称
          let obj = {};
          let peon = array.reduce((cur, next) => {
            obj[next.menuName] ? "" : obj[next.menuName] = true && cur.push(next);
            return cur;
          }, []) //设置cur默认类型为数组，并且初始值为空的数组
          if (peon.length == 0) {
            this.injectionOptions = this.list18
            this.listData = this.injectionOptions
          } else if (peon.length != 0) {
            this.injectionOptions = peon
            this.injectionOptions.unshift({ menuName: '无', id: 999999 }, { menuName: '其他', id: 111111 })
            this.listData = this.injectionOptions
          }
        }

      }
    },
    injectMatch(val) {
      this.copyinjectOptions = Object.assign(this.listData)
      if (val) {
        this.injectionOptions = this.copyinjectOptions.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.menuName) {
            if (item.menuName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.menuName, val)
          }
        })
      } else {
        this.injectionOptions = this.copyinjectOptions
      }
      // })
    },
    // 确定选择信息
    addInfo() {
      if (this.loadOption && this.loadOption != '') {
        // 提取数组中相同的元素
        let mobileArr = this.loadOptions.filter(item => this.loadOption.some(ele => ele === item.clientCard));
        // 多个电话号码数据处理 /拼接赋值.join('').replaceAll(' ', '/')
        let arr = (mobileArr.map((value) => value.clientMobile)).map(function (item) {
          return item.replaceAll(' ', '/')
        })
        // console.log(arr)
        // console.log(mobileArr.map((value) => value.clientMobile))
        let mobileRes = arr.join('/')
        // console.log(mobileRes)
        this.formData.clientMobile = mobileRes
        // 姓名处理
        let nameRes = mobileArr.map((value) => value.clientName).filter((num, index) => { return num !== '' }).join('/')
        this.formData.clientName = nameRes
        // 年龄处理
        // let ageRes = mobileArr.map((value) => value.clientAge).filter((num, index) => { return num !== '' }).join('/')
        // this.formData.clientAge = ageRes
        // 卡号处理
        let cardRes = mobileArr.map((value) => value.clientCard).filter((num, index) => { return num !== '' }).join('/')
        this.formData.clientCard = cardRes
        // 性别处理
        let sexRes = mobileArr.map((value) => value.clientSex).filter((num, index) => { return num !== '' }).join('/')
        this.formData.clientSex = sexRes
        // 客服处理
        let serviceRes = mobileArr.map((value) => value.serviceName).filter((num, index) => { return num !== '' }).join('/')
        // if (serviceRes != '/') {
        this.formData.serviceName = serviceRes
        // }
        // 渠道
        let channelRes = mobileArr.map((value) => value.scName).filter((num, index) => { return num !== '' }).join('/')
        this.formData.channel = channelRes
        //// this.formData.information = 0//0是1否   是否宏脉数据
        this.dialogFormCheck = false
      }
    },
    doctorChange(event, index) {
      if (this.formData.operationMaterials[index] != undefined) {
        this.formData.operationMaterials[index].doctorName = event
      }
      if (index == 0) {
        this.formData.registerInformationDtoList.forEach(item => {
          item.partDoctor = event
        });
        this.formData.operationMaterials.forEach(item => {
          item.doctorName = event
        });
      }

    },
    nurseChange(event, index) {
      if (this.formData.operationMaterials[index] != undefined) {
        this.formData.operationMaterials[index].nurseName = event
      }
      // 如果是第一条诊断则关联每一条诊断
      if (index == 0) {
        this.formData.registerInformationDtoList.forEach(item => {
          item.dutyNurse = event
        });
        this.formData.operationMaterials.forEach(item => {
          item.nurseName = event
        });
      }
    },
    // 诊断
    diagnosisChange(event, index) {
      // 如果是第一条诊断则关联每一条诊断
      if (index == 0) {
        this.formData.registerInformationDtoList.forEach(item => {
          item.diagnosis = event
        });
      }
    },
    // 治疗名称
    cureChange(event, index) {
      // 如果是第一条诊断则关联每一条诊断
      if (index == 0) {
        this.formData.registerInformationDtoList.forEach(item => {
          item.injectionPart = event
        });
      }
    },
    // 麻醉方式
    anesChange(event, index) {
      // 如果是第一条诊断则关联每一条诊断
      if (index == 0) {
        this.formData.registerInformationDtoList.forEach(item => {
          item.anesthesiaMode = event
        });
      }
    },
    // 备注
    remarkChange(event, index) {
      // 如果是第一条诊断则关联每一条诊断
      if (index == 0) {
        this.formData.registerInformationDtoList.forEach(item => {
          item.productRemark = event
        });
      }
    },
    // 确认修改信息
    doAddgoods(formData) {
      console.log(this.formData)
      this.$forceUpdate()
      this.$refs[formData].validate((valid) => {
        if (valid) {
          this.formData.operationMaterials.forEach(ele => {
            if (ele.doctorName) {
              ele.doctorName = ele.doctorName.toString()
            }
            if (ele.nurseName) {
              ele.nurseName = ele.nurseName.toString()
            }
            ele.injectionProductList.forEach(item => {
              item.injectionPart = item.injectionPart.toString()
            });
          });
          this.formData.registerInformationDtoList.forEach(ele => {
            if (ele.diagnosis) {
              ele.diagnosis = ele.diagnosis.toString()

            }
            if (ele.injectionPart) {
              ele.injectionPart = ele.injectionPart.toString()
            }
            if (ele.partDoctor) {
              ele.partDoctor = ele.partDoctor.toString()
            }
            if (ele.dutyNurse) {
              ele.dutyNurse = ele.dutyNurse.toString()
            }


          });
          console.log(this.formData)
          this.formData.userName = Lockr.get("userName")
          this.formData.createBy = Lockr.get("empId")
          this.formData.clientMobile = this.formData.clientMobile.replaceAll('，', ' ')
          var that = this
          api.requestQuiet("/register/createDermatologyRegister", this.formData, (res) => {
            if (res.result == true) {
              this.editSum = false;
              if (res.data != '') {
                _g.toast("success", '皮肤科登记表修改成功!');
                this.$emit('add-comment')
                this.$refs[formData].resetFields();
                this.formData.clientMobile = ''
                this.formData.clientCard = ''
                this.formData.clientName = ''

              }
            } else {
              _g.toast("error", res.errMsg);
            }
          }, (err) => {
            that.formData.operationMaterials.forEach(ele => {
              if (ele.doctorName) {
                ele.doctorName = ele.doctorName.split(',')

              }
              if (ele.nurseName) {
                ele.nurseName = ele.nurseName.split(',')
              }
              ele.injectionProductList.forEach(item => {
                item.injectionPart = item.injectionPart.split(',')
              });
            });
            that.formData.registerInformationDtoList.forEach(ele => {
              if (ele.diagnosis) {
                ele.diagnosis = ele.diagnosis.split(',')

              }
              if (ele.injectionPart) {
                ele.injectionPart = ele.injectionPart.split(',')
              }
              if (ele.partDoctor) {
                ele.partDoctor = ele.partDoctor.split(',')
              }
              if (ele.dutyNurse) {
                ele.dutyNurse = ele.dutyNurse.split(',')
              }
            });
          });
        } else {
          _g.toast("warning", '请完善信息');
          return false;
        }
      });
    },
    enterDoctor(e, index, val, idx, nextIndex) {
      if (val == 24) {//诊断
        if (this.diagnosisOptions[0].menuName != '无') {
          this.formData.registerInformationDtoList[index].diagnosis.push(this.diagnosisOptions[0].menuName)
        }
        this.diagnosisFocus(e, index)
      } else if (val == 25) {//治疗名称
        if (this.injectionOptions.length != 0 && this.injectionOptions[0].menuName != '无') {
          this.formData.registerInformationDtoList[index].injectionPart.push(this.injectionOptions[0].menuName)
        }
      } else if (val == 1) {//注射医生
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.registerInformationDtoList[index].partDoctor.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 2) {//当班护士
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.registerInformationDtoList[index].dutyNurse.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 3) {//手术名称
        if (this.infoOptions[0].menuName != '无') {
          this.formData.operationMaterials[index].injectionProductList[idx].injectionPart.push(this.infoOptions[0].menuName)
        }
      } else if (val == 4) {//医生姓名
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.operationMaterials[index].doctorName.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 5) {//护士姓名
        if (this.doctorOptions[0].menuName != '无') {
          this.formData.operationMaterials[index].nurseName.push(this.doctorOptions[0].menuName)
        }
      } else if (val == 30) {//产品名称
        if (this.productOptions[0] != undefined) {
          this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].productName = this.productOptions[0].menuName
          this.$refs.productName[idx].blur()
          this.productChange(this.formData.operationMaterials[index].injectionProductList[idx].productList[nextIndex].productName, idx, index, nextIndex)
        }
      } else if (val == 6) {//注射产品
        if (this.injectOptions[0] != undefined) {
          this.formData.operationMaterials[index].injectionProductList[idx].productName = this.injectOptions[0].menuName
          this.$refs.injectName[idx].blur()
          this.injectChange(this.formData.operationMaterials[index].injectionProductList[idx].productName, idx, index)
        }
      }
    }
  },
}
</script>
<style scoped>
.dialogItem >>> .el-input__inner {
  width: 200px;
  height: 38px;
}
.dialogItem >>> .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 200px;
  height: 38px;
}
.list >>> .el-input__inner {
  width: 88px;
  height: 38px;
}
.list1 >>> .el-input__inner {
  width: 150px;
  height: 38px;
}
.timeStyle >>> .el-input__inner {
  width: 500px;
  height: 38px;
}
.dialogItem >>> .el-form-item {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.addInjectable >>> .el-dialog {
  width: 1000px !important;
}
.card {
  background: #e0e6f0;
  border-radius: 10px;
  margin-bottom: 10px;
}
.flex {
  display: flex;
  align-items: center;
  /* background: #c3cedf;
  border-radius: 10px;
  margin-bottom: 5px; */
}
.allFlex {
  background: #c3cedf;
  border-radius: 10px;
  margin-bottom: 5px;
}
.addInjectable >>> .el-form-item__content {
  line-height: 35px !important;
}
.addInjectable >>> .el-button i {
  margin: 0 !important;
}
.info {
  margin-top: 18px;
}
.service >>> .el-input__inner {
  width: 140px;
  height: 38px;
}
.footer {
  display: flex;
  justify-content: center;
}
.cardName {
  margin-bottom: 50px;
}
.dialogItem >>> .el-checkbox-button--medium .el-checkbox-button__inner {
  text-align: left;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 10px;
}
.dialogItem >>> .el-checkbox-button__inner {
  border-left: 1px solid #dcdfe6;
}
.dialogItem >>> .el-radio--medium.is-bordered {
  width: 500px !important;
  height: 115px !important;
  /* line-height: 20px; */
  margin-bottom: 20px !important;
}
.dialogItem >>> .el-radio--medium.is-bordered .el-radio__label {
  font-size: 16px !important;
}
.dialogItem >>> .el-radio.is-bordered + .el-radio.is-bordered {
  margin-left: 0 !important;
}
.dialogItem >>> .el-radio__input {
  display: none;
}
.dialogItem >>> .el-radio__label {
  padding-left: 0 !important;
}
.infoSource {
  margin-bottom: 10px;
}
.nameSex {
  font-weight: bold;
  margin-left: 16px;
}
.dialogItem >>> .el-input--suffix .el-input__inner {
  padding-right: 5px;
}
</style>